import { EyesPreviewView } from './eyes-preview/EyesPreviewView'
import { useEyesPreview } from './eyes-preview/useEyesPreview'

export default function EyesPreview() {
  return <EyesPreviewView {...useEyesPreview()} />
}
